module.exports = __webpack_public_path__ + "static/img/icon3.df8d503.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/help/icon3.png
// module id = ft6Y
// module chunks = 1